<template>
  <div class="uplaod-attachments-button">
    <div
      v-if="isScanner"
      class="img-actions scan-button"
      @click="acquireImage"
    >
      <span>{{ local.common.scan }}</span>
      <v-icon>mdi-selection</v-icon>
    </div>
    <template v-else>
      <input
        :id="inputFileId"
        :ref="inputFileId"
        type="file"
        :accept="accept"
        :disabled="uploadDisabled"
        @change="inputFileChangeHandler"
      >
      <label
        :for="inputFileId"
        class="img-actions upload-attachment-button"
        aria-label="اضغط هنا لرفع المرفق" tabindex=1
        role="button"
      >
        <v-icon>mdi-cloud-outline</v-icon>
        <br>
        <span>{{ local.common.upload }}</span>
      </label>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { attachmentType } from '@/helpers/enum';
import { scanImage } from '@/helpers/scanner';
const { mapState } = createNamespacedHelpers('LawsuitModule');
import { uuidGenerator } from '@/helpers/utils';

export default {
  props: {
    isScanner: { type: Boolean },
    accept: {
      type: String,
      default: 'application/pdf, image/*',
    },
    maxFileSize: {
      type: Number,
      default: 20,
    },
    uploadDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { inputFileId: 0 };
  },
  mounted() {
    this.inputFileId = `attachment-file-input${uuidGenerator()}`;
  },
  computed: { ...mapState(['attachments']) },
  methods: {
    inputFileChangeHandler(e) {
      const file = e.target.files[0];
      if (!file || this.isFileExceededSize(file)) return;

      const acceptedMediaTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

      if (!acceptedMediaTypes.some(a => a.toLowerCase() == file.type.toLowerCase())) {
        this.toaster.error(this.local.attachments.errors.acceptedMediaTypes);
        return;
      }

      this.prepareFileObject(file);
    },
    prepareFileObject(file) {
      const attachmentKey = `${file.lastModified}${file.size}`;
      if (this.attachments.data[attachmentKey]) {
        this.$Notice.error({
          title: this.local.attachments.errors.thisFileUploadedBefore,
          top: 50,
          duration: 5,
        });
        this.resetFileInput();
        return;
      }
      const attachmentObject = {
        fileObject: file,
        fileType: file.type.match('image') ? attachmentType.image : attachmentType.pdf,
        name: file.name,
        extension: '.' + file.name.split('.').pop(),
        fileUrl: null,
        category: null,
      };
      this.$emit('fileSelected', {
        selectedAttachment: attachmentObject,
        selectedAttachmentKey: attachmentKey,
      });
      this.resetFileInput(); // reset file input value
    },

    resetFileInput() {
      if (this.$refs[this.inputFileId]) this.$refs[this.inputFileId].value = '';
    },

    acquireImage() {
      window.scroll(0, 0);
      /* eslint-disable no-undef */
      scanImage(({ file }) => {
        this.prepareFileObject(file);
      });
    },

    isFileExceededSize(file) {
      const fileSize = ((file.size / 1024) / 1024).toFixed(4); // mB

      if (fileSize > this.maxFileSize) {
        this.toaster.error(this.local.attachments.errors.sizeExceeded(this.maxFileSize));

        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
    .img-actions {
        width: 540px;
        color: #252733;
        text-align: center;
        font-size: 20px;
        border-radius: 6px;
        color: #252733;
        cursor: pointer;

        ::v-deep .v-icon {
            color: inherit;
        }

        &.scan-button {
            background-color: rgba(228, 230, 238, 0.5);
            padding: 10px;

            span {
                margin-left: 10px;
            }
        }

        &.upload-attachment-button {
            display: block;
            border: 2px dashed #f6f6f6;
            padding: 20px;
        }

        &:hover {
            color: #fff;
            background-color: var(--app-primary-color);
            border-color: var(--app-primary-color);
        }
    }
input {
  width: 0;
  height: 0;
  font-size: 0;
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
  position: absolute;
}
</style>
